class DateInputController {

    constructor(
        $state,
        $stateParams
    ) {
        'ngInject';

        this.$state = $state;
        this.$stateParams = $stateParams;
    }

    reloadCurrentState() {
        this.$state.reload(this.$state.current, this.$stateParams, {reload: true});
    }

}

export default DateInputController;


// WEBPACK FOOTER //
// ./app/common/breadcrumbs/breadcrumbs-controller.js